export const GET_VIDEO = {
  REQUEST: 'GET_VIDEO',
  PENDING: 'GET_VIDEO_PENDING',
  FAILED: 'GET_VIDEO_FAILED',
  FULFILLED: 'GET_VIDEO_FULFILLED'
}